import script from "./DashboardSidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSidePanel.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSidePanel.vue?vue&type=style&index=0&id=4b3e28db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3e28db"]])

export default __exports__